import React, { useState, useEffect } from 'react';

const Dropdown = ({ options, HandleChangeUom, UomName, UomIndex }) => {
  const [UomOptions, setUomOptions] = useState([]);

  useEffect(() => {
    const filteredOptions = options.filter(option =>
      option.label.toLowerCase().includes(UomName.toLowerCase())
    );
    setUomOptions(filteredOptions.length > 0 ? filteredOptions : options);
  }, [UomName, options]);

  return (
    <div className="bg-white shadow-md w-60 rounded-md p-2 absolute z-10 ">
      <ul>
        {UomOptions.map((option, i) => (
          <li
            key={i}
            className="py-2 px-4 hover:bg-gray-100 cursor-pointer"
            onClick={() => HandleChangeUom(option)}
          >
            {option.label}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Dropdown;
